import { Haptics, ImpactStyle } from "@capacitor/haptics";
import { Capacitor } from "@capacitor/core";
import { errorLog } from "./logger";

export const vibrateDevice = async () => {
  // Haptics requires the browser to support window.navigator.vibrate
  if (Capacitor.getPlatform() === "web" && (!window.navigator || !window.navigator.vibrate)) {
    return;
  }

  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch (e: any) {
    try {
      await Haptics.vibrate({ duration: 50 });
    } catch (fallbackError: any) {
      errorLog(fallbackError);
    }
  }
};
